import { Skeleton } from '@/components/ui/skeleton';

export function PurchaseOrderLayoutHeaderSkeleton() {
  return (
    <div className='flex items-center justify-between gap-4'>
      <Skeleton className='h-8 w-64' />
      <Skeleton className='h-10 w-36 rounded-full' />
    </div>
  );
}
